import React from "react";
import TextField from "../../../../../components/input-fields/TextField";
import { useSelector } from "react-redux";

const KnowledgeBaseTextItem = ({ item, index, onUpdateKnowledgeItem }) => {
  const { knowledgeItemErrors, config } = useSelector((state) => state.knowledgeBase);

  const onUpdateKnowledgeItemInternal = (key, value) => {
    onUpdateKnowledgeItem(key, value);
  };

  return (
    <div className="flex flex-col gap-6">
      <TextField
        title="Title"
        placeholder={"Title"}
        value={item.title}
        maxCharacters={config.maxKnowledgeItemTitleCharacters}
        onChange={(value) => onUpdateKnowledgeItemInternal("title", value)}
        errorMessage={knowledgeItemErrors[index]?.title}
        required
        lines={2}
        baseLine={1}
      />
      <TextField
        title="Information"
        placeholder={"Information"}
        value={item.value}
        maxCharacters={config.maxKnowledgeItemDescriptionCharacters}
        lines={4}
        onChange={(value) => onUpdateKnowledgeItemInternal("value", value)}
        errorMessage={knowledgeItemErrors[index]?.value}
        required
      />
    </div>
  );
};

export default KnowledgeBaseTextItem;
